import { BaseCrud } from '@/shared/models/cruds.models'
import { Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import { GetContextMenuItemsParams, MenuItemDef, RowNode } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'
import { initialLocalCaseValidationSituationsGridState, LocalCaseValidationSituationsGridState } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/components/local-case-validation-situations-grid/local-case-validation-situations-grid.model'
import { caseTypeValidationSituationConfigurationServices } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.service'
import LocalCaseValidationSituationsModal from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/components/local-case-validation-situations-modal/local-case-validation-situations-modal.vue'
import {
    ConfigurationCaseValidationSituationConfigurationCreateRequest,
    ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest,
    ConfigurationCaseValidationSituationConfigurationResponse
} from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.dto'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import { StrictNullable } from '@/shared/types/app.types'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        LocalCaseValidationSituationsModal
    }
})

export default class LocalCaseValidationSituationsGrid extends BaseCrudServerSideComponent<ConfigurationCaseValidationSituationConfigurationResponse> implements BaseCrud {
    @Ref() readonly localCaseValidationSituationsModalWrapper!: any

    state: LocalCaseValidationSituationsGridState
    constructor() {
        super()
        this.state = initialLocalCaseValidationSituationsGridState()
    }

    getContextMenuItems(params:GetContextMenuItemsParams): MenuItemDef[] {
        return [
            {
                name: this.$t('configuration.actions.update').toString(),
                cssClasses: this.state.selectedRows.length > 1 ? ['not-show'] : [''],
                action: () => {
                    const nodeSelected:StrictNullable<RowNode> = params?.node
                    const selectedRow: ConfigurationCaseValidationSituationConfigurationResponse = nodeSelected?.data
                    return this.showModal(this.$t('configuration.actions.update') as string, selectedRow, this.localCaseValidationSituationsModalWrapper)
                }
            },
            {
                name: this.$t('configuration.actions.delete').toString(),
                cssClasses: this.state.selectedRows.length < 1 ? ['not-show'] : [''],
                action: () => this.deleteOperation(this.state.selectedRows)
            }
        ]
    }

    async createOperation(row: ConfigurationCaseValidationSituationConfigurationCreateRequest): Promise<void> {
        this.$_updateLoading(true)
        const [err, response] = await this.$_toCall(caseTypeValidationSituationConfigurationServices.createCaseTypeValidationSituationsLaboratory(this.state.labId, row), true)
        this.$_updateLoading(false)
        if (err) {
            return
        } else if (response?.length) {
            this.$_handleErrors(response)
            return
        }
        this.localCaseValidationSituationsModalWrapper.$slots.default[0].componentInstance.updateRow(response)
        this.state = {
            ...this.state,
            actionTitle: i18n.t('configuration.actions.update').toString()
        }
        this.localCaseValidationSituationsModalWrapper.hide()
        this.$_showToastSuccess(this.$t('configuration.toastMessages.created')?.toString())
        this.reloadData()
    }
    async patchOperation(rows: ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest[]): Promise<void> {
        this.$_updateLoading(true)
        const [err, response] = await this.$_toCall(caseTypeValidationSituationConfigurationServices.patchCaseTypeValidationSituationsLaboratory(this.state.labId, rows), true)
        this.$_updateLoading(false)
        if (err) {
            return
        } else if (response?.length) {
            this.$_handleErrors(response)
            return
        }
        this.localCaseValidationSituationsModalWrapper.hide()
        this.$_showToastSuccess(this.$tc('configuration.toastMessages.updated', 1))
        this.reloadData()
    }
    async deleteOperation(rows: ConfigurationCaseValidationSituationConfigurationResponse[]): Promise<void> {
        if (rows.length) {
            const selectedRowsSize:number = this.state?.selectedRows?.length
            const labelConfirmation:string = this.$t('configuration.grid.deleteConfirmation')?.toString()
            const labelGrid: string = this.$tc('configuration.grid.element', selectedRowsSize)
            const labelDeleteQuestion:string = this.$t('configuration.grid.deleteQuestion')?.toString()
            const labelDeleteAction:string = this.$t('configuration.actions.delete')?.toString()
            const promise = await this.$_showConfirmationModal(
                `${labelConfirmation} ${selectedRowsSize} ${labelGrid}, <br/> ${labelDeleteQuestion}`,
                labelDeleteAction
            )
            if (promise) {
                await this._deleteBatchOperation(rows)
            }
        }
    }
    private async _deleteBatchOperation(rows: ConfigurationCaseValidationSituationConfigurationResponse[]): Promise<void> {
        const rowsToDelete: EntityIdentifiersRequest = {
            entityIdentifiers: rows.map(template => Number(template?.id))
        }
        this.$_updateLoading(true)
        const [err, response] = await this.$_toCall(caseTypeValidationSituationConfigurationServices.deleteCaseTypeValidationSituationsLaboratory(this.state.labId, rowsToDelete), true)
        this.$_updateLoading(false)
        if (err) {
            return
        } else if (response.length) {
            this.$_handleErrors(response)
            return
        }
        if (rows.length > 1) {
            this.$_showToastSuccess(
                this.$tc('configuration.toastMessages.deleted', 2, { elements: rows?.length })
            )
        } else {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted', 1))
        }
        this.reloadData()
    }
}
